import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getSkillsMatrixVersions, parseSkillsMatrix, applySkillsMatrix } from '@/api/skillsMatrixApi';
import type { ApplySkillsRequest } from '@/api/types/skillsMatrix.types';

export const skillsMatrixKeys = {
  all: ['skills-matrix'] as const,
  versions: () => [...skillsMatrixKeys.all, 'versions'] as const,
};

export function useSkillsMatrixVersions() {
  return useQuery({
    queryKey: skillsMatrixKeys.versions(),
    queryFn: getSkillsMatrixVersions,
  });
}

export function useParseSkillsMatrix() {
  return useMutation({
    mutationFn: parseSkillsMatrix,
  });
}

export function useApplySkillsMatrix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: ApplySkillsRequest) => applySkillsMatrix(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: skillsMatrixKeys.versions() });
    },
  });
}
